import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { Component, ViewChild } from '@angular/core';
import { AuthService } from 'src/app/auth/auth.service';
import { AccountService } from 'src/openapi-gen/services';
import { NavRoutes } from '../../../constants/nav.routes';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { ErrorResponseHandler } from 'src/app/shared/services/error-response-handler';
import { TransactionTypes } from '../../../constants/transaction.types';
import { FlexModule } from '@angular/flex-layout/flex';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { CommonModule } from '@angular/common';
import { HideIfUnauthorizedDirective } from '../../../../shared/directives/hide-if-unauthroized.directive';
import { HighlightDirective } from '../../../../shared/directives/highlight.directive';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MessageService } from 'primeng/api';
import { LoadingSpinnerComponent } from "../../../../shared/components/loading-spinner/loading-spinner.component";
import { FooterComponent } from '../../footer/footer.component';

@Component({
  selector: 'app-private-main',
  templateUrl: './private-main.component.html',
  styleUrls: ['./private-main.component.scss'],
  standalone: true,
  providers: [MessageService],
  imports: 
  [
    CommonModule, 
    FlexModule, 
    ExtendedModule, 
    RouterLink,
    RouterOutlet, 

    MatToolbarModule, 
    MatButtonModule, 
    MatIconModule, 
    MatSidenavModule, 
    MatListModule, 
    
    HighlightDirective, 
    HideIfUnauthorizedDirective, 

    LoadingSpinnerComponent, 
    FooterComponent,
  ]
})

export class PrivateMainComponent extends BaseComponent {
  @ViewChild(MatSidenav, { static: true }) sidenav: MatSidenav;
  @ViewChild(LoadingSpinnerComponent, { static: true }) loadingSpinner: LoadingSpinnerComponent;

  readonly routes = NavRoutes;
  readonly transaction = TransactionTypes;

  screenWidth: number;
  screenHeight: number;

  showAgencySubMenu: boolean = false;

  get fullName(): string {
    return this.authService.getFullName();
  }

  get role(): string {
    return this.authService.getRoleName();
  }
  
  constructor(
    private router: Router, 
    private errorResponseHandler: ErrorResponseHandler,
    private accountService: AccountService,
    private authService: AuthService,
  ) {
    super();
    this.screenWidth = window.innerWidth;
    this.screenHeight = window.innerHeight;

    window.onresize = () => {
      // set screenWidth on screen size change
      this.screenWidth = window.innerWidth;
      this.screenHeight = window.innerHeight;
    };
  }

  toggleSideNav() {
    this.sidenav.opened ? this.sidenav.close() : this.sidenav.open();
  }

  logout() {
    this.loadingSpinner.show();
    this.accountService
    .apiAccountLogoutPost()
    .subscribe({
      next: _ => {
        AuthService.SetUserLoggedOut();
        this.router.navigate([NavRoutes.Root]);
        this.loadingSpinner.hide();
      },
      error: (err) => {
        AuthService.SetUserLoggedOut();
        this.errorResponseHandler.handle_logout(err.status);
        this.loadingSpinner.hide();
      }
    });
  }

  shouldPlaceBottomPage(): boolean {
    switch (true) {
      case this.showAgencySubMenu:
        //Sum of toolbar height + each nav item height (with menu agency open) + footer height
        return this.screenHeight > 850;
      default:
        //Sum of toolbar height + each nav item height + footer height
        return this.screenHeight > 685;
    }
  }
}
